// extracted by mini-css-extract-plugin
export default {"root":"TaxesList_root__x+agk","root_nothing":"TaxesList_root_nothing__K1PsM","window":"TaxesList_window__MKGe7"};